import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';
import { DataTransferObject } from '../../../../../core/entities/DataTransferObject';
import { GuardianInfo } from './guardianinfo';

@Injectable()
export class GuardianinfoService extends AppService<any>  {

    constructor() {
        super('SMGuardian');
    }

    async getGuardian() {
        const result = await this.get('');
        return result;
    }

    async GetAllGuardians() {
        const result = await this.get('AllGuardians');
        return result;
    }

    async GetStudentAgainstGuardians() {
        let refentityid = this.localStorage.get("selectedEntity");
        const result = await this.get('StudentAgainstGuardians', [refentityid]);
        return result;
    }

    async getGuardianById(Id) {
        let refId = (Id == undefined || Id == 0 || Id == "") ? 'null' : Id;
        const result = await this.get('GuardianById', refId);
        return result;
    }

    async getGuardianList() {

        const clientid = Number(this.localStorage.get("clientid"));
        const result = await this.get('ClientGuardian', [clientid]);
        return result;
    }

    async getActivityGuardian() {
        const entityid = Number(this.localStorage.get("selectedEntity"));
        const result = await this.get('Activityguardian', [entityid]);
        return result;
    }


    async GuardianDefaulterList() {
        const entityid = Number(this.localStorage.get("selectedEntity"));
        const result = await this.get('GuardianDefaulterList', [entityid]);
        return result;
    }

    async GetEntityAgainstguardian(entityid) {

        const result = await this.get('EntityAgainstguardian', [entityid]);
        return result;
    }

    async getCurrentGuardian(Id) {
        const result = await this.get('', [Id]);
        return result;
    }

    async resetPassword(Id) {
        const result = await this.get('ResetPassword', [Id]);
        return result;
    }

    async SMGuardianreport(code) {
        const result = await this.get('Report', [code]);
        return result;
    }

    async getCourseAgainstGuardian(teacherid) {
        const entityid = Number(this.localStorage.get("selectedEntity"));
        const result = await this.get('courseagainstguardian', [entityid, teacherid]);
        return result;
    }
    async getAllGuardiansbycnic(cnic,contactno) {

        const result = await this.get('AllGuardiansbycnic', [cnic,contactno]);

        return result;
    }

}



// WEBPACK FOOTER //
// ./src/app/shell/forms/school-management/Admission/guardianinfo/guardianinfo.service.ts